import React, { useState } from 'react'

export default function Settings() {

    return(
        <div>Settings</div>
    )
}